var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTravelPlansHomeStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTravelPlansHomeStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.8834042,123.964401 C66.8143408,123.447602 67.0560627,122.758537 67.4359114,122.379552 L68.7135842,121.173688 L71.9940955,118.107349 C72.0286272,118.072896 72.0631589,118.038443 72.0976906,118.003989 C73.0645781,116.970392 73.4444268,114.730931 72.2703491,113.628427 C71.130803,112.525923 68.8862427,113.008269 67.9193551,114.041866 L63.6374246,118.658601 C63.2921076,119.037587 62.5669419,119.27876 62.0489665,119.209853 L43.9543567,116.62586 C43.4363813,116.556953 42.7457473,116.832579 42.434962,117.211565 L41.1918209,118.727508 C40.8465039,119.140947 40.9846307,119.588839 41.4680745,119.795558 L56.1785778,125.376984 C56.6620216,125.54925 56.7656167,126.031596 56.4202997,126.410582 L50.100999,133.128964 C50.0319356,133.163418 49.9283405,133.163418 49.8592771,133.163418 L42.780279,133.232324 C42.5040254,133.232324 42.2623035,133.439044 42.2277718,133.71467 L41.8824548,135.471785 C41.8479231,135.712958 41.9860499,136.023037 42.2277718,136.091944 L47.4075265,138.021325 C47.6492484,138.124685 47.925502,138.400311 47.9945654,138.641484 L49.9283405,143.809471 C50.0319356,144.050643 50.3081892,144.22291 50.549911,144.154003 L52.3110276,143.809471 C52.5527495,143.775018 52.7599397,143.499392 52.7944714,143.258219 L52.8635348,136.16085 C52.8635348,136.091944 52.8635348,136.023037 52.8980665,135.919677 L56.6965533,132.370993 L59.6662793,129.58028 C60.046128,129.235748 60.4950401,129.339107 60.7022302,129.821453 L66.2963653,144.532989 C66.4690238,145.015334 66.9524676,145.153147 67.366848,144.808615 L68.8862427,143.568298 C69.2660914,143.258219 69.5423449,142.569154 69.4732815,142.052355 L66.8834042,123.964401 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.8%",
    y: "-18.8%",
    width: "137.5%",
    height: "137.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.658967391 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-37.000000, -109.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icTravelPlansHomeStream"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTravelPlansHomeStream);
export default __webpack_public_path__ + "static/media/icTravelPlansHomeStream.69f1fdd284fe0ca44af5b33c4f8695ad.svg";
export { ForwardRef as ReactComponent };